export const LEADERBOARD_REQUEST = "LEADERBOARD_REQUEST";
export const LEADERBOARD_SUCCESS = "LEADERBOARD_SUCCESS";
export const LEADERBOARD_FAILURE = "LEADERBOARD_FAILURE";